import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useSubscription } from "@/hooks/use-subscription";
import { CreditCard, ExternalLink, Loader2 } from "lucide-react";
import { useState } from "react";

export function SubscriptionSection() {
  const { planName, planTier, status, isTrial, trialEndsAt, isFreemium, cancelAtPeriodEnd, currentPeriodEnd, openCustomerPortal, openCheckout } = useSubscription();
  const [loading, setLoading] = useState(false);

  const handleManage = async () => {
    setLoading(true);
    try {
      await openCustomerPortal();
    } catch {
      setLoading(false);
    }
  };

  const handleUpgrade = async () => {
    setLoading(true);
    try {
      await openCheckout("starter");
    } catch {
      setLoading(false);
    }
  };

  const statusLabels: Record<string, string> = {
    active: "Ativo",
    trialing: "Período de teste",
    past_due: "Pagamento pendente",
    canceled: "Cancelado",
    incomplete: "Incompleto",
    paused: "Pausado",
  };

  const statusVariants: Record<string, "default" | "secondary" | "destructive" | "outline"> = {
    active: "default",
    trialing: "secondary",
    past_due: "destructive",
    canceled: "outline",
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <CreditCard className="h-5 w-5" />
          Assinatura
        </CardTitle>
        <CardDescription>Gerencie seu plano e forma de pagamento</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="font-medium text-lg">{planName}</p>
            <div className="flex items-center gap-2 mt-1">
              <Badge variant={cancelAtPeriodEnd ? "destructive" : (statusVariants[status] || "outline")}>
                {cancelAtPeriodEnd ? "Cancelado" : (statusLabels[status] || status)}
              </Badge>
              {isTrial && trialEndsAt && (
                <span className="text-sm text-muted-foreground">
                  {cancelAtPeriodEnd
                    ? `Acesso gratuito até ${trialEndsAt.toLocaleDateString("pt-BR")}`
                    : `Teste gratuito até ${trialEndsAt.toLocaleDateString("pt-BR")}`
                  }
                </span>
              )}
              {!isTrial && cancelAtPeriodEnd && currentPeriodEnd && (
                <span className="text-sm text-muted-foreground">
                  Acesso até {currentPeriodEnd.toLocaleDateString("pt-BR")}
                </span>
              )}
            </div>
          </div>
        </div>

        {isFreemium ? (
          <Button onClick={handleUpgrade} disabled={loading} className="w-full sm:w-auto">
            {loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
            Fazer upgrade
          </Button>
        ) : (
          <Button onClick={handleManage} variant="outline" disabled={loading} className="w-full sm:w-auto">
            {loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <ExternalLink className="mr-2 h-4 w-4" />}
            Gerenciar assinatura
          </Button>
        )}
      </CardContent>
    </Card>
  );
}
